import { Button } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@/shared/ui/SearchInput';
import type { ContentToolbarProps } from './ContentToolbar.types';

export function ContentToolbar({
  title,
  itemCount,
  searchLabel,
  searchPlaceholder,
  searchValue = '',
  onSearchChange,
  createButton,
  extraActions,
  'data-testid': testId = 'content-toolbar',
}: ContentToolbarProps) {
  const { t } = useTranslation('common');
  const placeholder = searchPlaceholder ?? t('components.contentToolbar.searchPlaceholder');
  const displayTitle = title ? (itemCount !== undefined ? `${title} (${itemCount})` : title) : '';
  const showCreateButton = createButton && createButton.visible !== false;
  const createButtonIconPosition = createButton?.iconPosition ?? 'end';

  return (
    <div className="flex items-center justify-between px-8 py-6" data-testid={testId}>
      <div className="flex items-center gap-4">
        {displayTitle && <h2 className="text-sm font-medium">{displayTitle}</h2>}
        {onSearchChange && (
          <SearchInput
            value={searchValue}
            placeholder={placeholder}
            aria-label={searchLabel}
            className="bg-muted"
            onChange={onSearchChange}
          />
        )}
      </div>

      <div className="flex items-center gap-4">
        {extraActions}

        {showCreateButton && (
          <Button onClick={createButton.onClick}>
            {createButtonIconPosition === 'start' && <PlusIcon />}
            {createButton.label}
            {createButtonIconPosition === 'end' && <PlusIcon />}
          </Button>
        )}
      </div>
    </div>
  );
}
